export const modalSx = {
    root: {
        transition: "all .3s",
        border: "1px solid rgb(187, 187, 187)",
        borderRadius: "5px",
        display: "flex",
        flexDirection: "column",
        minWidth: {
            lg: '400px'
        },
        maxWidth: "100%",
        overflowY: "auto",
      '.lightTheme&':{
          backgroundColor: "#e6e6e6",
      }

    },
    info: {
        width: "100%",
        padding: "5px 5px 5px 15px",
        display: "flex",
        columnGap: "5px",
        alignItems: "center",
        justifyContent: "space-between",
        backgroundColor: "rgb(92 109 126)",
        height: '40px',
        title: {
            fontWeight: "600",
            display: "flex",
            justifyContent: "flex-start",
            columnGap: "10px",
            alignItems: "center",
            whiteSpace: "nowrap",
            maxWidth: "calc(100% - 70px)",
            overflowY: "auto",
            paddingLeft: "10px",
            color: '#fff'
        },
        action: {
            display: "flex",
            alignItems: "center",
            columnGap: "5px"
        },

    },
    content: {
        maxHeight: "95vh",
        height: "100%",
        minHeight: "150px",
        padding: {
            xs: '0 0 5px',
        },
        display: "flex",
        alignItems: "center",
        // flex-start rather than center: normal modals size to their content, so
        // it makes no difference there, while in fullscreen mode centering left the
        // content floating in the middle of an empty screen.
        justifyContent: "flex-start",
        flexDirection: "column",
        position: "relative",
        overflow: "hidden",
        inner: {
            transition: "all .3s",
            overflowY: "auto",
            padding: {
                xs: "0 5px 5px",
                lg: "0px 10px 5px",
            },
            width: "100%",
            height: "100%",
            minHeight: 0,
        },
        flex:1
    },
    close:{
        color:'white'
    }
}

export const toggleFullScreenSx = {

}